import routes from '@/projects/operation/views/ApiTest/router'
export default routes
